import React from "react";
import { View, Pressable, StyleSheet } from "react-native";
import Loader from "react-native-spinkit";
import color from "@constants/color";
import debounce from "lodash/debounce";
import Text from "@components/CustomText";

const PressableButton = (props) => {
  const {
    disabled = false,
    text = "",
    textStyle = {},
    buttonStyle = {},
    loading = false,
    onPress = () => {},
    debounceRate = 300,
    buttonColor = color.primary,
    testID = "",
    icon,
  } = props;

  const textStyles = [
    styles.submitButtonText,
    {
      ...textStyle,
    },
  ];
  const buttonStyles = [
    styles.submitButton,
    {
      ...buttonStyle,
      backgroundColor: !disabled ? buttonColor : color.lighterBlack,
    },
  ];

  const debouncedOnPress = debounce(onPress, debounceRate, {
    leading: true,
    trailing: false,
  });
  return (
    <Pressable
      pointerEvents={loading ? "none" : "auto"}
      disabled={disabled || loading}
      onPress={debouncedOnPress}
      testID={testID}
      style={buttonStyles}
    >
      <Loader
        style={styles.loader}
        isVisible={loading}
        size={28}
        type="ThreeBounce"
        color={color.white}
      />
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <Text
          style={[
            textStyles,
            { opacity: loading ? 0 : 1, marginRight: icon ? 8 : 0 },
          ]}
        >
          {text}
        </Text>
        {icon}
      </View>
    </Pressable>
  );
};

export default PressableButton;

const styles = StyleSheet.create({
  submitButton: {
    paddingHorizontal: 40,
    paddingVertical: 12,
    borderRadius: 10,
    minWidth: 180,
    alignItems: "center",
  },
  loader: {
    lineHeight: 28,
    position: "absolute",
    top: 12,
    flex: 1,
  },
  submitButtonText: {
    fontFamily: "Mulish-Bold",
    color: "white",
    fontSize: 20,
    lineHeight: 28,
  },
});
